import { useEffect, useRef, useState } from 'react';

function useHover() {
  const [isHover, setIsHover] = useState<boolean>(false);
  const elementRef = useRef(null);

  const onMouseEnter = () => setIsHover(true);
  const onMouseLeave = () => setIsHover(false);

  useEffect(() => {
    if (elementRef.current) {
      (elementRef.current as any).addEventListener('mouseenter', onMouseEnter);
      (elementRef.current as any).addEventListener('mouseleave', onMouseLeave);
    }
    return () => {
      if (elementRef.current) {
        (elementRef.current as any).removeEventListener(
          'mouseenter',
          onMouseEnter
        );
        (elementRef.current as any).removeEventListener(
          'mouseleave',
          onMouseLeave
        );
      }
    };
  }, [elementRef.current]);

  return [isHover, elementRef];
}

export default useHover;
